import { Text } from '@radix-ui/themes';
import { useEditorStore } from '../../stores';

export function AIAssistantMessage() {
    const { aiChatText } = useEditorStore();
    return (
        <Text as="span" size="3">
            Hi! I'm your AI assistant. {aiChatText ? `Describe the scene and we'll start from there. We can keep editting and adding details as we go.` : ''}
        </Text>
    );
}